module.exports = __webpack_public_path__ + "static/img/areaB_10.169a8f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_10.png
// module id = 1273
// module chunks = 1